/**
 * Accordion Exclusive - Only one details element open at a time within a container.
 * Closes siblings on summary click BEFORE the browser opens the new one,
 * preventing layout jumps.
 */
(function () {
  document.addEventListener('click', function (event) {
    var summary = event.target.closest('summary');
    if (!summary) return;

    var details = summary.closest('details');
    if (!details || details.open) return;

    var container = details.closest('[data-accordion-exclusive]');
    if (!container) return;

    var allDetails = container.querySelectorAll('details');
    for (var i = 0; i < allDetails.length; i++) {
      if (allDetails[i] !== details && allDetails[i].open) {
        allDetails[i].removeAttribute('open');
      }
    }
  }, true);
})();
